import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetRelease } from '../../api/use-get-release';
import { useGetPromoAccess } from '../../api/use-get-promo-access';
import { storedInteractions } from '../../utils/stored-interactions/stored-interactions';
import { Release } from '@repo/types/release';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ReleaseLayout } from '../../components/layout/release-layout';
import { Button } from '../../../../ui/button/button';
import { Input } from '../../../../ui/input/input';
import { ErrorMessage } from '../../components/error-message/error-message';
import { useGetReleaseIdFromParams } from '../../hooks/use-get-release-id-from-params/use-get-release-id-from-params';
import { InfoMessage } from '../../components/error-message/info-message';
import { useCheckPromoAccess } from '../../hooks/use-check-access/use-check-promo-access';

type AccessFormValues = { code: string };

export const PromoAccessPage = () => {
  const navigate = useNavigate();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<AccessFormValues>();
  const releaseId = useGetReleaseIdFromParams();
  const [accessCode, setAccessCode] = useState<string | undefined>();

  const { data: releaseData } = useGetRelease(releaseId);
  const { data, isSuccess, isLoading } = useGetPromoAccess(releaseId, {
    accessCode,
  });

  useCheckPromoAccess(releaseData?.catNr);

  const onSubmit: SubmitHandler<AccessFormValues> = ({ code }) => {
    setAccessCode(code);
  };

  const setHasAccess = (catNr: Release['catNr']) => {
    if (!storedInteractions.getHasPromoAccess(catNr)) {
      storedInteractions.setHasPromoAccess(catNr);
    }
  };

  useEffect(() => {
    if (accessCode && releaseData?.catNr && data?.hasAccess) {
      setHasAccess(releaseData.catNr);
      navigate(`/promo/${releaseId}`);
    }
  }, [accessCode, data, navigate, releaseId, releaseData]);

  return (
    <ReleaseLayout>
      <div className="min-h-[70vh] flex-1 flex flex-col justify-center items-center">
        <h1 className="heading1 mb-6">
          {releaseData?.artist}: {releaseData?.title}
        </h1>

        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
          <div>
            <Input
              type="text"
              {...register('code', { required: 'Password is required' })}
            />
            {errors.code && (
              <ErrorMessage text={errors.code.message as string} />
            )}
          </div>

          {!data?.hasAccess && isSuccess && (
            <ErrorMessage text="Wrong password!" />
          )}

          {isLoading && <InfoMessage text="Loading..." />}

          <Button>Submit</Button>
        </form>
      </div>
    </ReleaseLayout>
  );
};
